// extracted by mini-css-extract-plugin
module.exports = {"item":"_2L1f4GL6p1L-z8gqflbkFM","loader":"_1t7Nh_jbMweRZpO_WuKJFT"};